import styled from "styled-components";

const PageTitle = styled.h1`
  color: #333;
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 0;
  margin-bottom: 0;
  @media(max-width: 480px) {
    font-size: 24px;
  }
`;

export default PageTitle;